import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import useRequest from "../../../hooks/useRequest";
import Breadcrumb from "../../Breadcrumb/Breadcrumb";
import { Input, RenderInputFields, SubmitButton, SubTab, SubInput } from "../../Form/Form";
import { useSelector } from "react-redux";
import { API } from "../../../constant/api";
import { compareChanges } from "../../../util/fn";
import { CHANGES_REQ_MESSAGE } from "../../../util/other";

const Edit = (props) => {
  const { id: recordId } = props.match.params;
  const history = useHistory();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    control,
    reset
  } = useForm();
  const { languages } = useSelector((state) => state.setting);
  const { response: responseData, request: requestData } = useRequest();
  const { response, request } = useRequest();
  const [images, setImages] = useState(null);
  const [pdf, setPdf] = useState();
  const [displayPdf, setDisplayPdf] = useState();
  const [oldValues, setOldValues]                     = useState([]);

  useEffect(() => {
    if (recordId) {
      requestData("GET", `resource-document/${recordId}`);
      document.title = "Edit Document - Calevalab";
    }
  }, [recordId]);

  useEffect(() => {

    if (responseData) {
      const { title, document, langData } = responseData.data;
      const langDataWithoutId = langData.map(({ _id: _, ...rest }) => rest);
      const langDataShortedOld = langDataWithoutId.sort((a, b) => a.languageCode.localeCompare(b.languageCode));
      setOldValues({
        pdf: document,
        langData:langDataShortedOld,
        // link
      });
      const subData = {};
      if (langData?.length > 0) {
        langData.forEach((lang) => {
          const code = lang?.languageCode;
          subData["title-" + code] = lang?.title;
          // subData["subTitle-" + code] = lang?.subTitle;
          subData["id-" + code] = lang?._id;
        });
        reset({ ...subData });
      }
      setValue("title", title);
      // setValue("subTitle", subTitle);
      setValue("pdf",  document);
      // setValue("link", link);
      setPdf(document)
    }
  }, [responseData,setValue]);


  useEffect(() => {
    if (response) {
      toast.success("Document has been updated successfully.");
       history.push("/resources/document");
    }
  }, [response]);

  const onSubmit = (data) => {
    const langData = [];
    let fd = new FormData();

    for (let i = 0; i < languages.length; i++) {
      const code = languages[i].code;
      if (languages[i].default) {
        fd.append("title", data[`title-${code}`]);
      }
      langData.push({ id: data[`id-${code}`], languageCode: code, title: data[`title-${code}`] });
    }
    if (displayPdf) {
      if (data.pdf && data.pdf.length > 0) {
        fd.append("file", data.pdf[0]);
      }
    } else {
      if (pdf) {
        fd.append("old_pdf", pdf);
      }
    }
    const langDataWithoutId = langData.map(({ id: _, ...rest }) => rest);
    const langDataShorted = langDataWithoutId.sort((a, b) => a.languageCode.localeCompare(b.languageCode));

    let newData = {
      pdf: (data?.pdf?.length > 0 && data?.pdf[0]?.type) ? data.pdf[0] : pdf,
      langData:langDataShorted,
      // link: data?.link
    };

    if(compareChanges(oldValues,newData)){
          fd.append("langData", JSON.stringify(langData));
           fd.append("id", recordId);
         request("PUT", "resource-document", fd);
        }
        else {
          toast.error(CHANGES_REQ_MESSAGE);
        }
  };

  const handlePdf = (event) => {
    event.preventDefault();
    if (event.target.files[0]) {
      setDisplayPdf(URL.createObjectURL(event.target.files[0]));
      setPdf(event.target.files[0]);
      setValue('pdf', event.target.files[0]); 
      setError('pdf', ''); 
    } else {
      setDisplayPdf('');
      setPdf('');
      setValue('pdf', '');  
    }
  }
  
  const handleRemovePdf = () => {
    if (displayPdf) {
      setDisplayPdf(null);
      setValue("pdf", null);
    } else {
      setPdf(null);
    }
  }

  const InputFields = [
    [
      {
        Component: Input,
        label: "Title",
        type: "text",
        name: "title",
        registerFields: {
          required: true,
        },
      
      },
    ],
  ];

  const InputFieldsImage = [
    [
      {
        Component: Input,
        label: "PDF", 
        type: "file", 
        name: "pdf", 
        registerFields: {
          required: true, 
        },
        handleMedia: handlePdf, 
        handleRemoveMedia: handleRemovePdf,  
        isMedia: true, 
        accept:"application/pdf",
        control, 
        pdf,
        displayPdf,  
        media: "pdf", 
        mediaClass: "pdf-tab-media",
      },
    ],
  ];

  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title="Edit Document"
        links={[
          { to: "/", name: "Dashboard" },
          {
            to: { pathname: "/resources/document" /*backPageNum: page */ },
            name: "Back To Document",
          },
        ]}
      />

      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-xl-1"></div>
                <div className="col-xl-10">
                  <h3 className="mb-10 font-weight-bold text-dark">
                    Edit Document
                  </h3>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row"></div>
                    <div className="card card-custom gutter-b">
                      <div className="card-header card-header-tabs-line">
                        <div className="card-toolbar">
                          <ul
                            className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-bold nav-tabs-line-3x"
                            role="tablist"
                          >
                            {languages.length > 0 &&
                              languages.map((lang, index) => (
                                <SubTab
                                  key={index}
                                  name={lang.name}
                                  index={index}
                                  image={lang?.image}
                                />
                              ))}
                          </ul>
                        </div>
                      </div>
                      <div className="card-body px-0">
                        <div className="tab-content px-10">
                          {languages.length > 0 &&
                            languages.map((lang, index) => (
                              <>
                                <SubInput
                                  key={index}
                                  index={index}
                                  errors={errors}
                                  register={register}
                                  //   required={lang.default}
                                  required={true}
                                  // InputFields={InputFields}
                                  code={lang.code}
                                  InputFields={InputFields}
                                />
                              </>
                            ))}
                        </div>
                        <div className="row"></div>
                      </div>
                    </div>
                    <div className="row"></div>
                   
                    <RenderInputFields
                      InputFields={InputFieldsImage}
                      errors={errors}
                      register={register}
                    />
                  
                    <SubmitButton
                      handleSubmit={handleSubmit}
                      onSubmit={onSubmit}
                      name="Update"
                    />
                  </form>
                </div>
                <div className="col-xl-1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;
